export const workflowStatuses = [
  "RUNNING",
  "COMPLETED",
  "FAILED",
  "TIMED_OUT",
  "TERMINATED",
  "PAUSED",
];

export const TASK_STATUSES = [
  "IN_PROGRESS",
  "CANCELED",
  "FAILED",
  "FAILED_WITH_TERMINAL_ERROR",
  "COMPLETED",
  "COMPLETED_WITH_ERRORS",
  "SCHEDULED",
  "TIMED_OUT",
  "SKIPPED",
];

export const TASK_TYPES = [
  "ARCHER",
  "DECISION",
  "DO_WHILE",
  "DYNAMIC",
  "DYNIMO",
  "EAAS",
  "EVENT",
  "EXCLUSIVE_JOIN",
  "FORK_JOIN",
  "FORK_JOIN_DYNAMIC",
  "HTTP",
  "INLINE",
  "JOIN",
  "JSON_JQ_TRANSFORM",
  "LAMBDA",
  "SIMPLE",
  "SUB_WORKFLOW",
  "SWITCH",
  "TERMINATE",
  "TITUS",
  "TITUS_TASK",
  "WAIT",
];

// export const TASK_OPTIONS = [
//   "EVENT",
//   "HTTP",
//   "HTTP_POLL",
//   "INLINE",
//   "JSON_JQ_TRANSFORM",
//   "WAIT_FOR_WEBHOOK",
//   "JDBC",
//   "UPDATE_SECRET",
//   "SWITCH",
//   "DO_WHILE",
//   "WAIT",
//   "DYNAMIC",
//   "SET_VARIABLE",
//   "TERMINATE_WORKFLOW",
//   "TERMINATE",
//   "FORK_JOIN",
//   "FORK_JOIN_DYNAMIC",
//   "JOIN",
//   "START_WORKFLOW",
//   "HUMAN",
//   "SIMPLE",
//   {
//     type: "CUSTOM",
//     task: "STATUS_CHANGE",
//   },
//   {
//     type: "CUSTOM",
//     task: "APPROVAL",
//   },
//   {
//     type: "CUSTOM",
//     task: "REQUEST_DETAILS",
//   },
// ];

export const TASK_OPTIONS = [
  {
    task: "SIMPLE",
    type: "SYSTEM",
  },
  {
    task: "DYNAMIC",
    type: "SYSTEM",
  },
  {
    task: "FORK_JOIN",
    type: "SYSTEM",
  },
  {
    task: "FORK_JOIN_DYNAMIC",
    type: "SYSTEM",
  },
  {
    task: "DECISION",
    type: "SYSTEM",
  },
  {
    task: "SWITCH",
    type: "SYSTEM",
  },
  {
    task: "JOIN",
    type: "SYSTEM",
  },
  {
    task: "DO_WHILE",
    type: "SYSTEM",
  },
  {
    task: "SUB_WORKFLOW",
    type: "SYSTEM",
  },
  {
    task: "START_WORKFLOW",
    type: "SYSTEM",
  },
  {
    task: "EVENT",
    type: "SYSTEM",
  },
  {
    task: "WAIT",
    type: "SYSTEM",
  },
  {
    task: "HUMAN",
    type: "SYSTEM",
  },
  {
    task: "HTTP",
    type: "SYSTEM",
  },
  {
    task: "LAMBDA",
    type: "SYSTEM",
  },
  {
    task: "INLINE",
    type: "SYSTEM",
  },
  {
    task: "EXCLUSIVE_JOIN",
    type: "SYSTEM",
  },
  {
    task: "TERMINATE",
    type: "SYSTEM",
  },
  {
    task: "KAFKA_PUBLISH",
    type: "SYSTEM",
  },
  {
    task: "JSON_JQ_TRANSFORM",
    type: "SYSTEM",
  },
  {
    task: "SET_VARIABLE",
    type: "SYSTEM",
  },
  {
    task: "STATUS_CHANGE",
    type: "CUSTOM",
  },
  {
    task: "CREATE_FIREMON_TICKET",
    type: "CUSTOM",
  },
  {
    task: "APPROVAL",
    type: "CUSTOM",
  },
  {
    task: "REQUEST_DETAILS",
    type: "CUSTOM",
  },
  {
    task: "USER_DATA",
    type: "CUSTOM",
  },
  {
    task: "CI_DATA",
    type: "CUSTOM",
  },
  {
    task: "ADD_NOTES",
    type: "CUSTOM",
  },
  {
    task: "AWS_EC2_SERVICE",
    type: "CUSTOM",
  },
  {
    task: "SEND_EMAIL",
    type: "CUSTOM",
  },
  {
    task: "TRIGGER_WOLKEN_TASK",
    type: "CUSTOM",
  },
  {
    task: "DATA_PUSH_PULL",
    type: "CUSTOM",
  },
  {
    task: "DATABASE_ACCESS",
    type: "CUSTOM",
  },
  {
    task: "NOOP",
    type: "SYSTEM",
  },
];

export const ExecutionStatus = Object.freeze({
  InProgress: "IN_PROGRESS",
  Cancelled: "CANCELED",
  Failed: "FAILED",
  FailedWithTerminalError: "FAILED_WITH_TERMINAL_ERROR",
  Completed: "COMPLETED",
  CompletedWithErrors: "COMPLETED_WITH_ERRORS",
  Scheduled: "SCHEDULED",
  Timeout: "TIMED_OUT",
  Skipped: "SKIPPED",
});

export const TaskType = Object.freeze({
  Switch: "SWITCH",
  EndOfSwitch: "LABEL_END_OF_SWITCH",
  SwitchCase: "LABEL_SWITCH-CASE",
  Default: "LABEL_DEFAULT",
  Simple: "SIMPLE",
  ForkJoin: "FORK_JOIN",
  ForkBranch: "LABEL_FORK",
  EndOfForkJoin: "LABEL_END_OF_FORK_JOIN",
  DoWhile: "DO_WHILE",
  EndOfDoWhile: "LABEL_END_OF_DO_WHILE",
  Terminate: "TERMINATE",
  TriggerApproval: "TRIGGER_APPROVAL",
  FetchApproval: "FETCH_APPROVAL",
  Label: "LABEL",
  Terminal: "TERMINAL",
  StartTriggerApproval: "LABEL_START_TRIGGER_APPROVAL",
  EndTriggerApproval: "LABEL_END_TRIGGER_APPROVAL",
  Wait: "WAIT",

  StartSubWorkflow: "LABEL_START_SUB_WORKFLOW",
  EndSubWorkflow: "LABEL_END_SUB_WORKFLOW",
  SubWorkflow: "SUB_WORKFLOW",
  JoinTask: "JOIN",
  JsonTask: "JSON_JQ_TRANSFORM",
});

export const LabelNodeType = Object.freeze({});
export const SEARCH_TASK_TYPES_SET = modifyTaskTypes(TASK_TYPES);

function modifyTaskTypes(taskTypes) {
  const newTaskTypes = taskTypes.filter(
    (ele) => ele !== "FORK_JOIN_DYNAMIC" && ele !== "SIMPLE"
  );
  const fjIdx = newTaskTypes.findIndex((ele) => ele === TaskType.ForkJoin);
  newTaskTypes[fjIdx] = TaskType.ForkBranch;

  return new Set(newTaskTypes);
}

export const SERVER_SORTABLE_FIELDS = [
  "startTime",
  "endTime",
  "updateTime",
  "workflowId",
  "workflowType", // This appears to be "workflowName" in your requirements
  "status",
  "reasonForIncompletion",
  "executionTime",
];
export const SERVER_FILTERABLE_FIELDS = [
  // "startTime",
  // "endTime",
  // "updateTime",
  "workflowId",
  "workflowType",
  "status",
  // "reasonForIncompletion",
  // "executionTime",
  "workflowName",
  "requestId",
  "key",
];

export const FILTERABLE_FIELDS_WORKFLOW_DEF = ["workflowName"];
export const CATEGORY_WORKFLOW_DEF = ["Integration", "Ticket"];

export const pathToNavMap = {
  "/": "ex",
  "/search": "ex",
  "/search/tasks": "ex",
  "/workflowDef": "def",
  "/workflowDefs": "def",
  "/taskDefs": "def",
  "/taskDef": "def",
  "/eventHandlerDef": "def",
  "/taskQueue": "tskque",
  "/workbench": "wb",
  "/Admin": "admin",
};

export const routeMapping = {
  Execution: "/search",
  Definition: "/workflowDefs",
  "Task Queues": "/taskQueue",
  Workbench: "/workbench",
  Admin: "/Admin",
};

export const PAGINATION_PAGE_SIZE_OPTIONS = [5, 15, 30, 50, 100, 500];
export const DEFAULT_PAGINATION_PAGE_SIZE = 15;

export const EMPTY_SELECTED_ROWS = [];

export const EMPTY_CURRENT_FILTERS = {};
